<template>
  <div>
    <div v-for="(price, index) in prices" :key="index" class="price-row mb-4">
      <div class="d-flex">
        <span class="price">{{ formattedPrice(price) }}</span>
        <b-button variant="cart" @click="buyProduct(price)" class="py-1 px-3 ml-auto">
          <vue-element-loading :active="addingToCart" />
          {{ $t("product_price_list.add") }}
        </b-button>
      </div>
      <div class="pharmacy mt-2">
        {{ $t("product_price_list.published") }}:
        {{ price.manager_public_name }}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "product-price-list",
  props: {
    product: Object,
    maxPrices: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      addingToCart: false,
    };
  },
  computed: {
    prices() {
      if (this.maxPrices > 0) {
        return this.product.public_prices.slice(0, this.maxPrices);
      }
      return this.product.public_prices;
    },
  },
  methods: {
    formattedPrice(price) {
      return this.$formatMoney(
        price.all_included_price,
        price.all_included_price_currency
      );
    },
    buyProduct(price) {
      this.addingToCart = true;
      this.$store
        .dispatch("shoppingcart/ADD_PRODUCT", {
          product: this.product,
          price: price,
          quantity: 1,
        })
        .then(
          () => {
            this.addingToCart = false;
          },
          (err) => {
            if (err.error === "can_buy_only_if_has_logged") {
              this.mnotify_error({
                text: this.$t(
                  "product_price_list.error.can_buy_only_if_has_logged"
                ),
              });
            } else {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("product_price_list.error.buy_product"),
              });
            }
            this.addingToCart = false;
          }
        );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        product_price_list: {
          add: "Add to the cart",
          error: {
            buy_product: "Cannot add product to the shopping cart",
            can_buy_only_if_has_logged:
              "You can only buy this product if you are logged in",
          },
          published: "Published by",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.pharmacy {
  font-size: $font-size-small;
}

.price {
  color: $corp-color2;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.price-row:last-child {
  margin-bottom: 0 !important;
}
</style>
